import { render, staticRenderFns } from "./receipt_detail.vue?vue&type=template&id=1cbf886e&scoped=true&"
import script from "./receipt_detail.vue?vue&type=script&lang=js&"
export * from "./receipt_detail.vue?vue&type=script&lang=js&"
import style0 from "./receipt_detail.vue?vue&type=style&index=0&id=1cbf886e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf886e",
  null
  
)

export default component.exports